import React from 'react'
import useStore from '../../store/useStore'
import LightBoxCarousel from '../../components/Carousel/LightBoxCarousel'

const GeneralCarousel = () => {
  const { getImageByName } = useStore()
  const imgSlideArray = [
    { img: getImageByName('316paslanmazhasirtel'), alt: '316 Kalite Paslanmaz Hasır Tel' },
    { img: getImageByName('galvanizhasirtel6'), alt: 'Galvaniz Hasır Tel' },
    { img: getImageByName('galvanizhasirtel9'), alt: 'Galvaniz Hasır Tel' },
    { img: getImageByName('galvanizhasirtel10'), alt: 'Galvaniz Hasır Tel' },
    { img: getImageByName('hasirtel10'), alt: 'Hasır Tel' },
    { img: getImageByName('hasirtel13'), alt: 'Hasır Tel' },
    { img: getImageByName('hasirtel17'), alt: 'Hasır Tel' },
    { img: getImageByName('paslanmazcesan'), alt: 'Paslanmaz Çesan' },
    { img: getImageByName('paslanmazfens'), alt: 'Paslanmaz Fens' },
    { img: getImageByName('8mmpaslanmazhasirtel'), alt: '8mm Paslanmaz Hasır Tel' },
    { img: getImageByName('paslanmazhasirtel1'), alt: 'Paslanmaz Hasır Tel' },
    { img: getImageByName('paslanmazhasirtel4'), alt: 'Paslanmaz Hasır Tel' },
    { img: getImageByName('siyahhasirtel3'), alt: 'Siyah Hasır Tel' },
    { img: getImageByName('telkafes'), alt: 'Tel Kafes' },
    { img: getImageByName('siyahtelkafes'), alt: 'Siyah Tel Kafes' },
    { img: getImageByName('siyahhasirtel2'), alt: 'Siyah Tel Kafes' },
    { img: getImageByName('siyahhasirtel'), alt: 'Siyah Tel Kafes' },
    { img: getImageByName('siyahcelikhasir'), alt: 'Siyah Tel Kafes' },
    { img: getImageByName('puntakaynaklitel'), alt: 'Punta Kaynaklı Tel' },
    { img: getImageByName('paslanmaztelsepet3'), alt: 'Paslanmaz Tel Sepet' },
    { img: getImageByName('paslanmaztelsepet2'), alt: 'Paslanmaz Tel Sepet' },
    { img: getImageByName('paslanmaztelsepet'), alt: 'Paslanmaz Tel Sepet' },
    { img: getImageByName('paslanmazhasirtel2'), alt: 'Paslanmaz Hasır Tel' },
    { img: getImageByName('paslanmazkafestel'), alt: 'Paslanmaz Kafes Tel' },
    { img: getImageByName('paslanmazhasirtel7'), alt: 'Paslanmaz Hasır Tel' },
    { img: getImageByName('paslanmazhasirtel6'), alt: 'Paslanmaz Hasır Tel' },
    { img: getImageByName('paslanmazhasirtel5'), alt: 'Paslanmaz Hasır Tel' },
    { img: getImageByName('paslanmazhasirtel3'), alt: 'Paslanmaz Hasır Tel' },
    { img: getImageByName('ozelpaslanmazkafestel'), alt: 'Özel Paslanmaz Kafes Tel' },
    { img: getImageByName('ozelpaslanmazhasirtel'), alt: 'Özel Paslanmaz Hasır Tel' },
    { img: getImageByName('ozelolcucesan'), alt: 'Özel Ölçü Çeşan' },
    { img: getImageByName('ozelhasirtel2'), alt: 'Özel Hasır Tel' },
    { img: getImageByName('ozelhasirtel'), alt: 'Özel Hasır Tel' },
    { img: getImageByName('ozelgozpaslanmazhasirtel'), alt: 'Özel Göz Paslanmaz Hasır Tel' },
    { img: getImageByName('ozelgalvanizhasirtel'), alt: 'Özel Galvaniz Hasır Tel' },
    { img: getImageByName('hasirteltabela'), alt: 'Hasır Tel Tabela' },
    { img: getImageByName('hasirtelimalati'), alt: 'Hasır Tel İmalatı' },
    { img: getImageByName('hasirtel20'), alt: 'Hasır Tel' },
    { img: getImageByName('hasirtel19'), alt: 'Hasır Tel' },
    { img: getImageByName('hasirtel18'), alt: 'Hasır Tel' },
    { img: getImageByName('hasirtel16'), alt: 'Hasır Tel' },
    { img: getImageByName('hasirtel11'), alt: 'Hasır Tel' },
    { img: getImageByName('guvenlikbariyeri3'), alt: 'Güvenlik Bariyeri' },
    { img: getImageByName('guvenlikbariyeri2'), alt: 'Güvenlik Bariyeri' },
    { img: getImageByName('galvanizpaslanmazhasirtel'), alt: 'Galvaniz Paslanmaz Hasır Tel' },
    { img: getImageByName('galvanizkafestel'), alt: 'Galvaniz Kafes Tel' },
    { img: getImageByName('galvanizhasirtel14'), alt: 'Galvaniz Hasır Tel' },
    { img: getImageByName('galvanizhasirtel13'), alt: 'Galvaniz Hasır Tel' },
    { img: getImageByName('galvanizhasirtel5'), alt: 'Galvaniz Hasır Tel' },
    { img: getImageByName('galvanizhasirtel2'), alt: 'Galvaniz Hasır Tel' },
    { img: getImageByName('cercevelipaslanmazhasirtel'), alt: 'Çerçeveli Paslanmaz Hasır Tel' },
    { img: getImageByName('cercevelihasirtel'), alt: 'Çerçeveli Hasır Tel' },
    { img: getImageByName('caprazpaslanmazhasirtel'), alt: 'Çapraz Paslanmaz Hasır Tel' },
  ]
  return (
    <>
      <LightBoxCarousel imgArray={imgSlideArray} />
    </>
  )
}
export default GeneralCarousel
